/* eslint-disable no-underscore-dangle */
import React from 'react';
import { inject, observer } from 'mobx-react';
import UserModel from '@/models/user';
import MeetingModal from '@/models/meeting';
import ViewBox, { sizeTypes, viewBoxType } from '../ViewBox';
import Style from './index.less';
import { ViewBoxEvent, eventBus } from '@/utils/event';

interface ViewPanelProps {
  meeting?: MeetingModal;
  user?: UserModel;
}

enum MAIN_VIEW {
  ME = 'me',
  OTHER = 'other',
}

const Lecturer: React.FC<ViewPanelProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
    user: store.user,
  };
})(
  observer((props: ViewPanelProps) => {
    const { meeting, user } = props;
    const viewPanelRef = React.useRef<HTMLDivElement>(null);
    const viewPanelWrapRef = React.useRef<HTMLDivElement>(null);
    const [mainView, setMainView] = React.useState<MAIN_VIEW>(MAIN_VIEW.OTHER);
    const [mainYxid, setmainYxid] = React.useState('');
    const [smallYxId, setsmallYxId] = React.useState('');

    const changeMainView = React.useCallback(() => {
      let otherUser = '';
      meeting?.sortMembers.forEach((value) => {
        if (value.yxUidStr !== user?.yxuid) {
          otherUser = value.yxUidStr;
        }
      });
      if (mainView === MAIN_VIEW.OTHER) {
        setmainYxid(String(otherUser));
        setsmallYxId(String(user?.yxuid));
      } else {
        setmainYxid(String(user?.yxuid));
        setsmallYxId(String(otherUser));
      }
    }, [mainView, user?.yxuid, meeting?.sortMembers]);

    React.useEffect(() => {
      changeMainView();
    }, [mainView]);

    const switchMainView = React.useCallback(() => {
      eventBus.emit(ViewBoxEvent.Play);

      if (mainView === MAIN_VIEW.OTHER) {
        setMainView(MAIN_VIEW.ME);
      } else {
        setMainView(MAIN_VIEW.OTHER);
      }
    }, [mainView]);
    // 改变的时候play
    return (
      <div className={`${Style['view-panel-wrap']} ${Style.lecturer}`} ref={viewPanelWrapRef}>
        <div className={Style['view-panel']} ref={viewPanelRef}>
          {smallYxId && (
            <ViewBox
              key={String(smallYxId)}
              yxuid={String(smallYxId) || ''}
              type={viewBoxType.video}
              sizeType={sizeTypes.small}
              className={Style['small-box']}
              onClick={switchMainView}
              avatarSize={48}
            />
          )}
          {mainYxid && (
            <ViewBox
              key={String(mainYxid)}
              yxuid={String(mainYxid) || ''}
              type={viewBoxType.video}
              sizeType={sizeTypes.full}
              avatarSize={100}
            />
          )}
        </div>
      </div>
    );
  })
);
export default Lecturer;
